import React, {useContext, useState} from "react";
import {Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack, InputBase, IconButton, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Alert02Icon, CheckIcon, Plug01Icon, Key01Icon, Cancel01Icon} from "@hugeicons/core-free-icons";
import {Context} from "../../../../context/AppContext"

const controlSx = {height: 40, display: "flex", alignItems: "center", gap: 1, px: 1.25, borderRadius: "10px", bgcolor: "#FAFAFD", color: "#6B6B80", fontSize: 13};

const EditTokenModalNew = ({open, onClose, onSave, server}) => {
    const [newToken, setNewToken] = useState('');
    const [testing, setTesting] = useState(false);
    const [tested, setTested] = useState(false);
    const [testResult, setTestResult] = useState(null);
    const {testMCPConnection} = useContext(Context);

    const handleTest = async () => {
        if (!server.endpoint) return;
        setTesting(true);
        const data = await testMCPConnection({endpoint: server.endpoint, auth_token: newToken});
        setTestResult(data);
        setTested(data?.ok || false);
        setTesting(false);
    };

    const handleSave = () => {
        onSave(newToken);
        setNewToken('');
        setTestResult(null);
        setTested(false);
        onClose();
    };

    const handleClose = () => {
        setNewToken('');
        setTestResult(null);
        setTested(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{sx: {borderRadius: '20px', boxShadow: '0 24px 70px rgba(35, 38, 77, 0.22)'}}}>
            <DialogTitle sx={{p: 3, pb: 2}}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Box>
                        <Typography sx={{fontSize: 18, fontWeight: 700, color: '#23264D', letterSpacing: '-0.01em'}}>Update Authorization</Typography>
                        <Typography sx={{fontSize: 13, color: '#8A8AA0', mt: 0.5}}>Set new authentication token</Typography>
                    </Box>
                    <IconButton size="small" onClick={handleClose} sx={{color: '#8A8AA0'}}><HugeiconsIcon icon={Cancel01Icon} size={18} /></IconButton>
                </Stack>
            </DialogTitle>

            <DialogContent sx={{p: 3, pt: 2}}>
                <Box>
                    <Typography sx={{fontSize: 12, fontWeight: 600, color: '#6B6B80', mb: 0.75, textTransform: 'uppercase', letterSpacing: '0.05em'}}>Authorization Token</Typography>
                    <Box sx={{...controlSx, mb: 2.5}}>
                        <HugeiconsIcon icon={Key01Icon} size={16} />
                        <InputBase type="password" placeholder="Enter authorization token" value={newToken} onChange={e => {setNewToken(e.target.value); setTestResult(null); setTested(false);}} inputProps={{"aria-label": "Authorization token"}} sx={{flex: 1, fontSize: 13, color: "#23264D"}} />
                    </Box>
                </Box>

                <Button size="small" disabled={testing || !newToken} startIcon={testing ? <CircularProgress size={14}/> : <HugeiconsIcon icon={Plug01Icon} size={16}/>} onClick={handleTest} sx={{textTransform: "none", borderRadius: '10px', fontWeight: 600, fontSize: 13, color: '#8491F7', '&:hover': {bgcolor: 'rgba(132, 145, 247, 0.08)'}}}>{testing ? "Testing..." : "Test Connection"}</Button>

                {testResult && (<Alert severity={testResult.ok ? "success" : "error"} icon={testResult.ok ? <HugeiconsIcon icon={CheckIcon} size={18}/> : <HugeiconsIcon icon={Alert02Icon} size={18}/>} sx={{borderRadius: '10px', fontSize: 13, mt: 1.5, ...(testResult.ok ? {bgcolor: 'rgba(47, 154, 106, 0.08)', color: '#2F9A6A', border: '1px solid #2F9A6A'} : {bgcolor: 'rgba(220, 38, 38, 0.08)', color: '#DC2626', border: '1px solid #DC2626'})}}>{testResult.message}{testResult.ok && testResult.server_name && (<Box component="span" sx={{display: "block", fontSize: 12, opacity: 0.8, mt: 0.5}}>{testResult.server_name}{testResult.protocol_version && ` · MCP ${testResult.protocol_version}`}{testResult.tool_count != null && ` · ${testResult.tool_count} tools`}</Box>)}</Alert>)}
            </DialogContent>

            <DialogActions sx={{p: 3, pt: 2, gap: 1.5}}>
                <Button onClick={handleClose} sx={{textTransform: 'none', fontWeight: 600, fontSize: 13, borderRadius: '10px', color: '#374151', bgcolor: '#FAFAFD', '&:hover': {bgcolor: '#ECECF3'}}}>Cancel</Button>
                <Button disabled={!newToken || !tested} onClick={handleSave} sx={{textTransform: 'none', fontWeight: 600, fontSize: 13, borderRadius: '10px', bgcolor: '#374151', color: '#fff', '&:hover': {bgcolor: '#1F2937'}, '&.Mui-disabled': {bgcolor: '#D1D5DB', color: '#9CA3AF'}}}>Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditTokenModalNew;
